import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-quick-session-stepper',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './quick-session-stepper.component.html',
  styleUrls: ['./quick-session-stepper.component.css']
})
export class QuickSessionStepperComponent implements OnInit {
  @Input() initialTime: string = '10:00';
  @Input() stepMinutes: number = 30;
  @Input() disabled: boolean = false;

  @Output() confirm = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  timeControl = new FormControl('10:00', [
    Validators.required,
    Validators.pattern('^([01]?[0-9]|2[0-3]):[0-5][0-9]$')
  ]);

  ngOnInit(): void {
    this.timeControl.setValue(this.initialTime);
    if (this.disabled) {
      this.timeControl.disable();
    }
  }

  onConfirm(): void {
    if (this.timeControl.valid && this.timeControl.value) {
      this.confirm.emit(this.timeControl.value);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  increment(): void {
    this.adjustTime(this.stepMinutes);
  }

  decrement(): void {
    this.adjustTime(-this.stepMinutes);
  }

  private adjustTime(minutesToAdd: number): void {
    const currentTimeStr = this.timeControl.value;
    if (!currentTimeStr || !this.timeControl.valid) {
      return;
    }

    const [hoursStr, minutesStr] = currentTimeStr.split(':');
    let hours = parseInt(hoursStr, 10);
    let minutes = parseInt(minutesStr, 10);

    let totalMinutes = hours * 60 + minutes + minutesToAdd;

    // Handle daily wrapping
    totalMinutes = totalMinutes % (24 * 60);
    if (totalMinutes < 0) {
      totalMinutes += 24 * 60;
    }

    const newHours = Math.floor(totalMinutes / 60);
    const newMinutes = totalMinutes % 60;

    const formattedTime = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
    this.timeControl.setValue(formattedTime);
  }
}
